import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { acessoPermitido } from '../../acessos.seguranca';
import ListagemCommonContainer from './listagem/listagem.common.container';
import PesquisaCommonContainer from './pesquisa/pesquisa-common.container';
import DraggablePanel from '@componentes/floatingPanel/DraggablePanel.component';
import {ModalLogin, DivLoginAnimation} from 'vivace-fluent-motion';
import * as acessos from '../../acessos.const.util';
import { injectIntl, useIntl } from 'react-intl';

const MainCommonPage = (props) => {
  const intl = useIntl()
  
  return (
    <div>      
      <DivLoginAnimation usuario={props.usuario.usuario} />     
      <Container fluid className='mv-workspace-container'>
        <Row>
          {<ModalLogin usuario={props.usuario.usuario} visivel={props.splash} delay="3s" message = {intl.formatMessage({ id: 'message.welcome' })} />}
          {acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
            acessoPermitido(props.usuario, acessos.Filtrar) && (
              <Col>
                <Row className='mv-filtro-container'>
                  <PesquisaCommonContainer
                    intl={intl}
                    pagina={props.pagina}
                    listagem={props.listagem}
                    listagemTotal={props.listagemTotal}
                    listagemExibido={props.listagemExibido}
                  />
                </Row>
                <Row>
                  <ListagemCommonContainer
                    intl={intl}
                    altura={props.altura}
                    pagina={props.pagina}
                    loadListagem={props.loadListagem}
                    listagemTotal={props.listagemTotal}
                    listagemExibido={props.listagemExibido}
                    listagem={props.listagem}
                    history={props.history}
                  />
                </Row>
              </Col>
            )}
        </Row>

        
    
      </Container>

      <DraggablePanel title={props.draggablePanelTitle}>
        {props.draggablePanelContent !== undefined && (
          <textarea
            value={props.draggablePanelContent}
            disabled={true}
          ></textarea>
        )}
      </DraggablePanel>
    </div>
  );
};

export default injectIntl (MainCommonPage);


// WEBPACK FOOTER //
// ./src/pages/main/main.common.page.js